// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"18054cc6","453":"251b83fe"}[chunkId] + ".chunk.js";
};